import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/Modal'
import gql from 'graphql-tag'
import { Row, Col } from 'react-flexbox-grid'
import DxDataTable from 'components/DxDataTable'

import { useQuery } from 'components/graphql'

const fieldsQuery = gql`
	query listAvailableParameters{
	  cashAssist {
			listAvailableParameters {
				id
				type
				name
			}
		}
	}
`

const historyQuery = gql`
	query listConfigHistory($paramId:ID!, $cashRegisterId: ID!) {
		cashAssist {
			listConfigHistory(paramId: $paramId, cashRegisterId: $cashRegisterId) {
				id
				value
				dateStart
				historyUserId
			}
		}
	}
`

export const SettingsHistoryModal = ({ unmount, data }) => {
	const [t] = useTranslation()
	const [selectedField, setSelectedField] = useState({})
	const fieldsResult = useQuery(fieldsQuery, { fetchPolicy: 'cache-first' })
	const historyResult = useQuery(historyQuery, {
		skip: !selectedField.id,
		variables: { paramId: selectedField.id, cashRegisterId: data.id }
	})
	return(
		<Modal unmount={unmount} label={t('common.strings.history')}>
			<Row>
				<Col xs={6}>
					<DxDataTable
						id='billsTable'
						height={500}
						columns={[{
							caption: t('common.strings.parameter'),
							dataField: 'name',
							searchable: true
						}]}
						data={fieldsResult.data?.listAvailableParameters}
						withSearch
						onRowClick={setSelectedField}
						loading={fieldsResult.loading}
					/>
				</Col>
				<Col xs={6}>
					<DxDataTable
						height={500}
						columns={[{
							caption: t('common.strings.value'),
							dataField: 'value',
							searchable: true
						}, {
							caption: t('common.fields.date'),
							dataField: 'dateStart',
							searchable: true,
							customizeText: ({ value }) => new Date(value).toLocaleString()
						}]}
						data={historyResult.data?.listConfigHistory || []}
						withSearch
						loading={historyResult.loading}
					/>
				</Col>
			</Row>
		</Modal>
	)
}
